const MilesstoneItem = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='94'
    height='59'
    viewBox='0 0 94 59'
    fill='none'
  >
    <path
      d='M4.5975 9.44513L85.6256 1.24987C87.1386 1.09683 88.6076 1.81506 89.416 3.10316L92.6964 8.32966C93.9377 10.3075 93.228 12.9237 91.1574 14.0031L6.84897 57.9511C4.18597 59.3392 0.999998 57.4071 0.999998 54.4041L0.999999 13.4248C1 11.3715 2.55464 9.65174 4.5975 9.44513Z'
      fill='#272829'
      stroke='#3F4042'
    />
  </svg>
);

export default MilesstoneItem;
